import axios from "axios";
import { getToken, logoutAdmin, isTokenExpired } from "../utils/auth";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../config/api";

let tokenExpiredCallback = null;

export const setTokenExpiredCallback = (callback) => {
  tokenExpiredCallback = callback;
};

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    console.log(err.response?.status, "response status");
    if (err.response?.status === 413 || err.status === 413 || err.message?.includes('413')) {
      toast.error("Please select another image as this is large in size");
    }
    if (err.response?.status === 401 || err.response?.status === 403) {
      // if (tokenExpiredCallback) {
      //   tokenExpiredCallback();
      // } else {
      //   logoutAdmin();
      //   window.location.href = "/";
      // }
    }
    return Promise.reject(err);
  }
);

export default api;
